'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

var _noop = require('lodash/noop');

var _noop2 = _interopRequireDefault(_noop);

var _getStyles = require('./get-styles');

var _getStyles2 = _interopRequireDefault(_getStyles);

var _textMessage = require('./text-message');

var _textMessage2 = _interopRequireDefault(_textMessage);

var _imageMessage = require('./image-message');

var _imageMessage2 = _interopRequireDefault(_imageMessage);

var _giphyMessage = require('./giphy-message');

var _giphyMessage2 = _interopRequireDefault(_giphyMessage);

var _videoMessage = require('./video-message');

var _videoMessage2 = _interopRequireDefault(_videoMessage);

var _stickerMessage = require('./sticker-message');

var _stickerMessage2 = _interopRequireDefault(_stickerMessage);

var _audioMessage = require('./audio-message');

var _audioMessage2 = _interopRequireDefault(_audioMessage);

var _themeable = require('../themeable');

var _themeable2 = _interopRequireDefault(_themeable);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var displayName = 'Message';

var propTypes = {
  /** Path to the user's profile image will only be rendered if provided */
  avatar: _propTypes2.default.string,
  /** The message's body text */
  body: _propTypes2.default.node.isRequired,
  /** Time when the message was created */
  createdAt: _propTypes2.default.node.isRequired,
  /** The sender's username */
  username: _propTypes2.default.node.isRequired,
  /** The message's type */
  type: _propTypes2.default.oneOf(['text', 'image', 'sticker', 'giphy', 'video', 'audio']),
  /** Override the styles of the root element */
  style: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the header element */
  messageHeaderStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the body element */
  messageBodyStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the time element */
  messageTimeStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** The message size. One of the following: ["small", "medium", "large"] */
  fontSize: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  /** Flag used to change message styles. True if the message was sent by the current user */
  myMessage: _propTypes2.default.bool,
  /** Enable emojione for messages */
  emoji: _propTypes2.default.bool,
  /** Enables links in messages */
  enableLinks: _propTypes2.default.bool,
  /** Enables compact messages */
  compact: _propTypes2.default.bool,
  /** Enables Lighbox for image messages */
  enableLightbox: _propTypes2.default.bool,
  /** Collapse an image message */
  collapsed: _propTypes2.default.bool,
  /** Text to display for collapsed messages */
  collapsedText: _propTypes2.default.node,
  /** Text to display above giphy messages */
  giphyDescription: _propTypes2.default.node,
  /** Text to display for edited banner */
  edited: _propTypes2.default.node,
  /** Show a separator above the message */
  separator: _propTypes2.default.node,
  /**
   * Highlight text, must be an array of objects containing id, value, and prefix.
   *
   * Text matching '[prefix][value]' will be highlighted
   */
  highlights: _propTypes2.default.arrayOf(String),
  /**
   * Callback fired when highlighted text is clicked
   *
   * function(event: object, highlight: object) => void
   */
  onHighlightClick: _propTypes2.default.func,
  /** Badge to display next to username */
  badge: _propTypes2.default.node,
  /** Render an IconMenu in Message */
  iconMenu: _propTypes2.default.node,
  /** Enables multiline messages */
  enableMultiline: _propTypes2.default.bool,
  /** ImageLoader props, see https://ui.anchor.chat/#/image-loader */
  imageLoaderProps: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Video node to display a video url within a player */
  video: _propTypes2.default.node,
  /**
   * Audio object
   *
   * {
   *   onPlay: function(event: object) => void,
   *   onPause: function(event: object) => void,
   *   isPlaying: Boolean,
   *   progress: Number,
   *   time: Node
   * }
   */
  audio: _propTypes2.default.shape({
    onPlay: _propTypes2.default.func.isRequired,
    onPause: _propTypes2.default.func.isRequired,
    isPlaying: _propTypes2.default.bool.isRequired,
    progress: _propTypes2.default.number.isRequired,
    time: _propTypes2.default.node.isRequired
  }),
  color: _propTypes2.default.string.isRequired
};

var defaultProps = {
  avatar: '',
  type: 'text',
  style: {},
  messageHeaderStyle: {},
  messageBodyStyle: {},
  messageTimeStyle: {},
  fontSize: 'small',
  myMessage: false,
  emoji: false,
  enableLinks: false,
  compact: false,
  enableLightbox: false,
  collapsed: false,
  collapsedText: 'This image has been collapsed.',
  giphyDescription: 'Sent using /giphy',
  edited: null,
  separator: null,
  highlights: [],
  onHighlightClick: _noop2.default,
  badge: null,
  iconMenu: null,
  enableMultiline: false,
  imageLoaderProps: {},
  video: null,
  audio: {
    onPlay: _noop2.default,
    onPause: _noop2.default,
    isPlaying: false,
    progress: 0,
    time: '00:00'
  }
};

/** Messages with optional styling for the current user's message,
different font sizes and message styles */
var Message = function Message(props) {
  var avatar = props.avatar,
      body = props.body,
      createdAt = props.createdAt,
      username = props.username,
      type = props.type,
      myMessage = props.myMessage,
      style = props.style,
      messageHeaderStyle = props.messageHeaderStyle,
      messageBodyStyle = props.messageBodyStyle,
      messageTimeStyle = props.messageTimeStyle,
      compact = props.compact,
      fontSize = props.fontSize,
      emoji = props.emoji,
      enableLinks = props.enableLinks,
      enableLightbox = props.enableLightbox,
      collapsed = props.collapsed,
      collapsedText = props.collapsedText,
      edited = props.edited,
      highlights = props.highlights,
      onHighlightClick = props.onHighlightClick,
      color = props.color,
      separator = props.separator,
      badge = props.badge,
      giphyDescription = props.giphyDescription,
      iconMenu = props.iconMenu,
      enableMultiline = props.enableMultiline,
      imageLoaderProps = props.imageLoaderProps,
      audio = props.audio,
      custom = _objectWithoutProperties(props, ['avatar', 'body', 'createdAt', 'username', 'type', 'myMessage', 'style', 'messageHeaderStyle', 'messageBodyStyle', 'messageTimeStyle', 'compact', 'fontSize', 'emoji', 'enableLinks', 'enableLightbox', 'collapsed', 'collapsedText', 'edited', 'highlights', 'onHighlightClick', 'color', 'separator', 'badge', 'giphyDescription', 'iconMenu', 'enableMultiline', 'imageLoaderProps', 'audio']);

  var messageElement = _react2.default.createElement(_textMessage2.default, _extends({ color: color }, props));

  if (type === 'image') {
    messageElement = _react2.default.createElement(_imageMessage2.default, _extends({ color: color }, props));
  }

  if (type === 'sticker') {
    messageElement = _react2.default.createElement(_stickerMessage2.default, _extends({ color: color }, props));
  }

  if (type === 'giphy') {
    messageElement = _react2.default.createElement(_giphyMessage2.default, _extends({ color: color }, props));
  }

  if (type === 'video') {
    messageElement = _react2.default.createElement(_videoMessage2.default, _extends({ color: color }, props));
  }

  if (type === 'audio') {
    messageElement = _react2.default.createElement(_audioMessage2.default, _extends({ color: color }, props));
  }

  return _react2.default.createElement(
    'div',
    { style: _styles2.default.root },
    separator,
    _react2.default.createElement(
      'section',
      _extends({ style: _getStyles2.default.container(myMessage, compact) }, custom),
      messageElement
    )
  );
};

Message.displayName = displayName;
Message.propTypes = propTypes;
Message.defaultProps = defaultProps;

var enhance = (0, _compose2.default)((0, _themeable2.default)(), _radium2.default);

exports.default = enhance(Message);
module.exports = exports.default;